export default {
  name: 'prodify',
  component() {
      return {
        el: '',
        pickerType: '',
        selectors: '',
        textStrings: '',
        currentVariant: '',
        optionContainers: '',
        options: '',
        variantData: '',
        embossing: {
          enabled: false,
          name: '',
          id: '',
        },
        popup: false,
        body: "",
        scrollTopLock: 0,
        specsLabels:
        [
          {
            "handle": "wc_aantalversnellingen",
            "value": "Number of gears"
          },
          {
            "handle": "wc_accuampereuur",
            "value": "Battery amp hours"
          },
          {
            "handle": "wc_acculocatie",
            "value": "Battery location"
          },
          {
            "handle": "wc_accuoplaadbaarinfiets",
            "value": "Battery chargeable on bike"
          },
          {
            "handle": "wc_accuvermogen",
            "value": "Battery capacity"
          },
          {
            "handle": "wc_accuvoltage",
            "value": "Battery voltage"
          },
          {
            "handle": "wc_afneembaardisplay",
            "value": "Removable display"
          },
          {
            "handle": "wc_frametype",
            "value": "Frame type"
          },
          {
            "handle": "wc_gemiddeldactieradius",
            "value": "Average range"
          },
          {
            "handle": "wc_handvatbediening",
            "value": "Handlebar controls"
          },
          {
            "handle": "wc_hoofdkleur",
            "value": "Main color"
          },
          {
            "handle": "wc_jaar",
            "value": "Year"
          },
          {
            "handle": "wc_kleur",
            "value": "Color"
          },
          {
            "handle": "wc_leasemaanden",
            "value": "Lease months"
          },
          {
            "handle": "wc_leaseplatform",
            "value": "Lease platform"
          },
          {
            "handle": "wc_leasetype",
            "value": "Lease type"
          },
          {
            "handle": "wc_leverbaarvanaf",
            "value": "Available from"
          },
          {
            "handle": "wc_leverstatus",
            "value": "Delivery status"
          },
          {
            "handle": "wc_maat",
            "value": "Size"
          },
          {
            "handle": "wc_materiaal",
            "value": "Material"
          },
          {
            "handle": "wc_merk",
            "value": "Brand"
          },
          {
            "handle": "wc_merkaccu",
            "value": "Battery brand"
          },
          {
            "handle": "wc_merkbanden",
            "value": "Tire brand"
          },
          {
            "handle": "wc_merkcasette",
            "value": "Cassette brand"
          },
          {
            "handle": "wc_merkcrankset",
            "value": "Crankset brand"
          },
          {
            "handle": "wc_merkderailleurachter",
            "value": "Rear derailleur brand"
          },
          {
            "handle": "wc_merkderailleurvoor",
            "value": "Front derailleur brand"
          },
          {
            "handle": "wc_merkdisplay",
            "value": "Display brand"
          },
          {
            "handle": "wc_merkdragers",
            "value": "Rack brand"
          },
          {
            "handle": "wc_merkhandvattape",
            "value": "Handlebar tape brand"
          },
          {
            "handle": "wc_merkheadset",
            "value": "Headset brand"
          },
          {
            "handle": "wc_merkketting",
            "value": "Chain brand"
          },
          {
            "handle": "wc_merkmotor",
            "value": "Motor brand"
          },
          {
            "handle": "wc_merkpowertrain",
            "value": "Powertrain brand"
          },
          {
            "handle": "wc_merkremmenprimairachter",
            "value": "Rear brake brand"
          },
          {
            "handle": "wc_merkremmensecundairachter",
            "value": "Rear brake brand"
          },
          {
            "handle": "wc_merkremmenvoor",
            "value": "Front brake brand"
          },
          {
            "handle": "wc_merkschakelkabels",
            "value": "Shift cable brand"
          },
          {
            "handle": "wc_merkshifters",
            "value": "Shifter brand"
          },
          {
            "handle": "wc_merkspatborden",
            "value": "Fender brand"
          },
          {
            "handle": "wc_merkstandaard",
            "value": "Kickstand brand"
          },
          {
            "handle": "wc_merkstuur",
            "value": "Handlebar brand"
          },
          {
            "handle": "wc_merkstuurpen",
            "value": "Stem brand"
          },
          {
            "handle": "wc_merkverlichtingachter",
            "value": "Rear light brand"
          },
          {
            "handle": "wc_merkverlichtingvoor",
            "value": "Front light brand"
          },
          {
            "handle": "wc_merkversnellingen",
            "value": "Gear brand"
          },
          {
            "handle": "wc_merkvoorvork",
            "value": "Front fork brand"
          },
          {
            "handle": "wc_merkwielen",
            "value": "Wheel brand"
          },
          {
            "handle": "wc_merkzadel",
            "value": "Saddle brand"
          },
          {
            "handle": "wc_merkzadelpen",
            "value": "Seatpost brand"
          },
          {
            "handle": "wc_merkzadelpenklem",
            "value": "Seatpost clamp brand"
          },
          {
            "handle": "wc_minimumbereik",
            "value": "Minimum range"
          },
          {
            "handle": "wc_model",
            "value": "Model"
          },
          {
            "handle": "wc_modelaccu",
            "value": "Battery model"
          },
          {
            "handle": "wc_modelbanden",
            "value": "Tire model"
          },
          {
            "handle": "wc_modelcasette",
            "value": "Cassette model"
          },
          {
            "handle": "wc_modelcrankset",
            "value": "Crankset model"
          },
          {
            "handle": "wc_modelderailleurachter",
            "value": "Rear derailleur model"
          },
          {
            "handle": "wc_modelderailleurvoor",
            "value": "Front derailleur model"
          },
          {
            "handle": "wc_modeldragers",
            "value": "Rack model"
          },
          {
            "handle": "wc_modelhandvattape",
            "value": "Handlebar tape model"
          },
          {
            "handle": "wc_modelheadset",
            "value": "Headset model"
          },
          {
            "handle": "wc_modelketting",
            "value": "Chain model"
          },
          {
            "handle": "wc_modelmotor",
            "value": "Motor model"
          },
          {
            "handle": "wc_modelremmenprimairachter",
            "value": "Rear primary brake model"
          },
          {
            "handle": "wc_modelremmensecundairachter",
            "value": "Rear secondary brake model"
          },
          {
            "handle": "wc_modelremmenvoor",
            "value": "Front brake model"
          },
          {
            "handle": "wc_modelschakelkabels",
            "value": "Shift cable model"
          },
          {
            "handle": "wc_modelshifters",
            "value": "Shifter model"
          },
          {
            "handle": "wc_modelspatborden",
            "value": "Fender model"
          },
          {
            "handle": "wc_modelstandaard",
            "value": "Kickstand model"
          },
          {
            "handle": "wc_modelstuur",
            "value": "Handlebar model"
          },
          {
            "handle": "wc_modelstuurpen",
            "value": "Stem model"
          },
          {
            "handle": "wc_modelverlichtingachter",
            "value": "Rear light model"
          },
          {
            "handle": "wc_modelverlichtingvoor",
            "value": "Front light model"
          },
          {
            "handle": "wc_modelversnellingen",
            "value": "Gear model"
          },
          {
            "handle": "wc_modelvoorvork",
            "value": "Front fork model"
          },
          {
            "handle": "wc_modelwielen",
            "value": "Wheel model"
          },
          {
            "handle": "wc_modelzadel",
            "value": "Saddle model"
          },
          {
            "handle": "wc_modelzadelpen",
            "value": "Seatpost model"
          },
          {
            "handle": "wc_modelzadelpenklem",
            "value": "Seatpost clamp model"
          },
          {
            "handle": "wc_motorlocatie",
            "value": "Motor location"
          },
          {
            "handle": "wc_oplaadtijdnormalelader",
            "value": "Charging time standard charger"
          },
          {
            "handle": "wc_oplaadtijdsnellader",
            "value": "Charging time fast charger"
          },
          {
            "handle": "wc_plaatsbepaling",
            "value": "Positioning / tracking"
          },
          {
            "handle": "wc_standactieradius",
            "value": "Standard range"
          },
          {
            "handle": "wc_typeaccu",
            "value": "Battery type"
          },
          {
            "handle": "wc_typebediening",
            "value": "Control type"
          },
          {
            "handle": "wc_typedisplay",
            "value": "Display type"
          },
          {
            "handle": "wc_typeelektrischefiets",
            "value": "Electric bike type"
          },
          {
            "handle": "wc_typemotor",
            "value": "Motor type"
          },
          {
            "handle": "wc_typepowertrain",
            "value": "Powertrain type"
          },
          {
            "handle": "wc_typeremmenprimairachter",
            "value": "Rear primary brake type"
          },
          {
            "handle": "wc_typeremmensecundairachter",
            "value": "Rear secondary brake type"
          },
          {
            "handle": "wc_typeremmenvoor",
            "value": "Front brake type"
          },
          {
            "handle": "wc_typesensor",
            "value": "Sensor type"
          },
          {
            "handle": "wc_typeversnellingen",
            "value": "Gear type"
          },
          {
            "handle": "wc_walkassist",
            "value": "Walk assist"
          },
          {
            "handle": "wc_wattagemotor",
            "value": "Motor wattage"
          },
          {
            "handle": "wc_wielmaat",
            "value": "Wheel size"
          },
          {
            "handle": "wc_custom1",
            "value": "Size"
          },
          {
            "handle": "wc_custom2",
            "value": "Color"
          },
          {
            "handle": "wc_custom3",
            "value": "Gender"
          },
          {
            "handle": "wc_custom4",
            "value": "Product type filter (subcategorie)"
          },
          {
            "handle": "wc_custom5",
            "value": "Season"
          },

        ],
        // quantityIncrementButton: '',
        // quantityDecrementButton: '',
        // quantityPresentationInput: '',
        // quantityHiddenInput: '',

        init() {
          this.body = document.querySelector("body");

          this.el = this.$root;
          this.pickerType = this.el.dataset.prodify;
      
          this.selectors = {
            priceContainer: '[data-prodify-price-container]',
            mediaContainer: '[data-prodify-media-container]',
            variantsJson: '[data-prodify-variants-json]',
            optionContainer: '[data-prodify-option-container]',
            productForm: '[data-prodify-product-form]',
            // quantityIncrement: '[data-prodify-quantity-increment]',
            // quantityDecrement: '[data-prodify-quantity-decrement]',
            // quantityPresentation: '[data-prodify-quantity-presentation]',
          }
      
          this.textStrings = {
            addToCart: window.variantStrings.addToCart,
            unavailableVariantValueLabel: window.variantStrings.unavailable_with_option,
            soldOutVariantValueLabel: window.variantStrings.soldout_with_option,
            addButtonTextUnavailable: window.variantStrings.unavailable,
          }

          // this.quantityIncrementButton = this.el.querySelector(this.selectors.quantityIncrement)
          // this.quantityDecrementButton = this.el.querySelector(this.selectors.quantityDecrement)
          // this.quantityPresentationInput = this.el.querySelector(this.selectors.quantityPresentation)
          // this.quantityHiddenInput = this.el.querySelector('input[name="quantity"]')
      
          this.initEventListeners();

        },
      
        initEventListeners() {
          // this.el.addEventListener('change', (e) => {
          //   this.onVariantChange(e);
          // });
      
          // if (
          //   this.quantityIncrementButton &&
          //   this.quantityDecrementButton &&
          //   this.quantityPresentationInput
          // ) {
          //   this.quantityIncrementButton.addEventListener('click', () => {
          //     this.updateQuantity('up')
          //   })
      
          //   this.quantityDecrementButton.addEventListener('click', () => {
          //     this.updateQuantity('down')
          //   })
          // }

          this.onVariantChange()
          
          // this.updateCurrentVariant()

        },

        enableBodyScrollLock() {
            this.scrollTopLock =
                document.documentElement.scrollTop || document.body.scrollTop;
            this.body.style.overflow = "hidden";
            this.body.style.position = "fixed";
            this.body.style.top = `-${this.scrollTopLock}px`;
            this.body.style.width = "100%";
        },
    
        disableBodyScrollLock() {
            this.body.style.removeProperty("overflow");
            this.body.style.removeProperty("position");
            this.body.style.removeProperty("top");
            this.body.style.removeProperty("width");
            window.scrollTo(0, this.scrollTopLock);
        },

        onVariantChange() {
          this.updateCurrentOptions()
          this.updateCurrentVariant()
          this.compareInputValues()

          // this.updateAddButtonDom(true, '', false)
          // this.setOptionSelected(this.$el)
          
          if (!this.currentVariant) {
            // this.updateAddButtonDom(true, this.textStrings.addButtonTextUnavailable, true)
          } else {
            this.updateURL()
            this.updateVariantIdInput()
            this.slideToVariantMedia()
            // this.swapProductInfo()
          }
        },

        slideToVariantMedia() {
          const section = this.$el.closest('[data-section]')
          if (!section) return
          const script = section.querySelector('[data-product-variant-media-index]')
          if (!script || !this.currentVariant) return
          let index
          try {
            const map = JSON.parse(script.textContent)
            index = map[this.currentVariant.id]
          } catch {
            return
          }
          if (typeof index !== 'number') return
          const mainSlider = section.querySelector('.swiper')
          if (!mainSlider?.productSwiper) return
          mainSlider.productSwiper.slideTo(index)
        },
      
        updateCurrentVariant() {
          const variants = this.getVariantData();

          if(variants.length > 1) {
              const matchingVariant = variants.find(variant => {
                return variant.options.every((option, index) => {
                  return this.options[index] === option;
                });
              });
                          
              if (matchingVariant) {
                this.currentVariant = matchingVariant;
              } else {
                const newVariant = variants.find(variant => variant.option1 === this.options[0]);
                this.currentVariant = newVariant;
              }
          } else {
            this.currentVariant = variants[0];
          }          
        },
      
        // updateQuantity(stepDirection) {
        //   const previousQuantity = parseInt(this.quantityPresentationInput.value)
      
        //   if (stepDirection == 'up') {
        //     this.quantityHiddenInput.value = this.quantityPresentationInput.value = previousQuantity + 1
        //   } else {
        //     this.quantityHiddenInput.value = this.quantityPresentationInput.value = Math.max(1, previousQuantity - 1)
        //   }
        // },
      
        updateCurrentOptions() {
          this.optionContainers = Array.from(this.el.querySelectorAll(this.selectors.optionContainer))

          if (this.optionContainers.length > 0) {
            this.options = this.optionContainers.map((optionContainer) => {
              const select = optionContainer.querySelector('select');
              if (select) {
                return select.value;
              }
              const inputs = Array.from(optionContainer.querySelectorAll('input'));
              let option = inputs.find((input) => input.checked);
              if (!option && inputs.length > 0) {
                option = inputs[0];
                option.checked = true;
              }
              return option ? option.value : '';
            });
            return;
          }

          if (this.pickerType == 'select') {
            this.options = Array.from(this.el.querySelectorAll('select'), (select) => select.value)
            return
          } else if (this.pickerType == 'radio') {
            this.options = Array.from(this.el.querySelectorAll('input[type="radio"]:checked'), (radio) => radio.value)
            return
          }
        },
      
        updateVariantIdInput() {
          const productForms = this.$root.querySelectorAll(this.selectors.productForm)
          productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]')
            input.value = this.currentVariant.id
            // input.dispatchEvent(new Event('change', { bubbles: true }));
          })
        },
      
        updateURL() {
          if (!this.currentVariant || this.el.dataset.updateUrl === 'false') return
          window.history.replaceState({}, '', `${this.el.dataset.url}?variant=${this.currentVariant.id}`)
        },
      
        // updateAddButtonDom(disable = true, text, modifyClass = true) {
        //   const productForm = this.$root.querySelector(this.selectors.productForm)
        //   if (!productForm) return
        //   const addButton = productForm.querySelector('[name="add"]')
        //   const addButtonText = productForm.querySelector('[name="add"] > span')
        //   if (!addButton) return
      
        //   if (disable) {
        //     addButton.setAttribute('disabled', 'disabled')
        //     if (text) addButtonText.textContent = text
        //   } else {
        //     addButton.removeAttribute('disabled')
        //     addButtonText.textContent = this.textStrings.addButtonTextUnavailable
        //   }
      
        //   if (!modifyClass) return
      
        //   if (disable) {
        //     addButton.classList.add('disabled')
        //   } else {
        //     addButton.classList.remove('disabled')
        //   }
        // },
            
        // setOptionSelected(select) {
        //   if (this.pickerType == 'select') {
        //     const options = Array.from(select.querySelectorAll('option'))
        //     const currentValue = select.value
      
        //     options.forEach((option) => {
        //       if (option.value === currentValue) {
        //         option.setAttribute('selected', 'selected')
        //       } else {
        //         option.removeAttribute('selected')
        //       }
        //     })
        //   }
        // },
      
        compareInputValues() {
          // Get the first option value (either from select or checked radio)
          // Use the first option container that contains a select
          // const optionContainers = this.el.querySelector(this.selectors.optionContainer);
          // let firstOptionContainer = null;
          // for (const container of optionContainers) {
          //   if (container.querySelector('select') !== null) {
          //     firstOptionContainer = container;
          //     break;
          //   }
          // }

          const firstOptionContainer = this.el.querySelector(this.selectors.optionContainer);


          let firstOptionValue = '';
          if (firstOptionContainer) {

            const firstSelect = firstOptionContainer.querySelector('select');
            if (firstSelect) {
              firstOptionValue = firstSelect.value;
            } else {
              let firstChecked = null;
              if(firstOptionContainer.querySelector(':checked') !== null) {
                firstChecked = firstOptionContainer.querySelector(':checked');
              } else {
                firstChecked = firstOptionContainer.querySelector('input[type="radio"]');
                firstChecked.checked = true;
              }
              // const firstChecked = firstOptionContainer.querySelector(':checked');
              if (firstChecked) {
                firstOptionValue = firstChecked.value;
              }
            }
          }

          const variantsMatchingOptionOneSelected = this.variantData.filter(
            // Grab the first checked input and compare it to the variant option1
            // return an array of variants where the option1 matches the checked input
            (variant) => firstOptionValue === variant.option1
          )
      
          const inputWrappers = [...this.el.querySelectorAll(this.selectors.optionContainer)]
          inputWrappers.forEach((option, index) => {
            // console.log(index);
            if (index === 0) return
            
            // Get inputs for this option (either select options or radio buttons)
            const select = option.querySelector('select');
            const optionInputs = select 
              ? [...select.querySelectorAll('option')]
              : [...option.querySelectorAll('input[type="radio"]')]
            
            // Get the previous option's selected value
            const previousContainer = inputWrappers[index - 1];
            let previousOptionSelected = '';
            const previousSelect = previousContainer.querySelector('select');
            if (previousSelect) {
              previousOptionSelected = previousSelect.value;
            } else {
              const previousChecked = previousContainer.querySelector(':checked');
              if (previousChecked) {
                previousOptionSelected = previousChecked.value;
              }
            }
            
            const availableOptionInputsValues = variantsMatchingOptionOneSelected
              .filter(
                (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])

            const existingOptionInputsValues = variantsMatchingOptionOneSelected
              .filter(
                (variant) => variant[`option${index}`] === previousOptionSelected
              )
              .map((variantOption) => variantOption[`option${index + 1}`])

            this.setInputAvailability(optionInputs, availableOptionInputsValues, existingOptionInputsValues)
      
          })
        },
      
        setInputAvailability(optionInputs, availableOptionInputValues, existingOptionInputsValues) {
          const valueMatches = (arr, val) => {
            if (val == null || val === '') return false
            const normalized = String(val).trim()
            return arr.some((item) => String(item).trim() === normalized)
          }

          optionInputs.forEach((input) => {
            const isSelectOption = input.tagName === 'OPTION';
            const inputValue = input.getAttribute('value');

            if (valueMatches(availableOptionInputValues, inputValue)) {
              if (isSelectOption) {
                const currentText = input.textContent.trim();
                const baseValue = currentText.split(' - ')[0];
                input.textContent = baseValue.trim();
                input.disabled = false;
                return
              }
              input.classList.remove('disabled')
              input.classList.remove('disabled--option')
            } else {
              if (valueMatches(existingOptionInputsValues, inputValue)) {
                if (isSelectOption) {
                  const currentText = input.textContent.trim();
                  const baseValue = currentText.split(' - ')[0].trim();
                  input.textContent = this.textStrings.soldOutVariantValueLabel.replace(
                    '[value]',
                    baseValue
                  )
                  input.disabled = true;
                  return
                }
                input.classList.add('disabled')
                input.classList.add('disabled--option')
              } else {
                if (isSelectOption) {
                  // Get base value from current text (remove any existing suffix)
                  const currentText = input.textContent.trim();
                  const baseValue = currentText.split(' - ')[0];
                  input.textContent = this.textStrings.unavailableVariantValueLabel.replace(
                    '[value]',
                    baseValue
                  )
                  input.disabled = true;
                  return
                }
                input.classList.add('disabled')
              }
            }
          })
        },

        zoom(e) {
            const zoomer = this.$el;
            let offsetX;
            let offsetY;

            this.$event.offsetX ? offsetX = this.$event.offsetX : offsetX = this.$event.touches[0].pageX;
            this.$event.offsetY ? offsetY = this.$event.offsetY : offsetX = this.$event.touches[0].pageX;
            const x = offsetX / zoomer.offsetWidth*100;
            const y = offsetY/zoomer.offsetHeight*100;

            zoomer.style.backgroundPosition = x + '% ' + y + '%';
        },
      
        // swapProductInfo() {
        //   window[window.slayedNamespace].helpers
        //     .fetchHTML(
        //       `${this.el.dataset.url}?variant=${this.currentVariant.id}`
        //     )
        //     .then((responseHTML) => {
        //       const priceSource = responseHTML.querySelector(this.selectors.priceContainer)
        //       const priceTarget = this.el.querySelector(this.selectors.priceContainer)
        //       const mediaSource = responseHTML.querySelector(this.selectors.mediaContainer)
        //       const mediaTarget = this.el.querySelector(this.selectors.mediaContainer)
        //       const addButtonSource = responseHTML.querySelector(
        //         `${this.selectors.productForm} [name="add"]`
        //       )
        //       const addButtonTarget = this.el.querySelector(`${this.selectors.productForm} [name="add"]`)
      
        //       console.log(responseHTML)
        //       console.log(priceTarget)

        //       if (priceSource && priceTarget) {
        //         priceTarget.replaceWith(priceSource)
        //       }
      
        //       if (mediaSource && mediaTarget) {
        //         mediaTarget.replaceWith(mediaSource)
        //       }
      
        //       if (addButtonSource && addButtonTarget) {
        //         addButtonTarget.replaceWith(addButtonSource)
        //       }
      
        //     })
        // }, 
      
        getVariantData() {
          this.variantData =
            this.variantData || JSON.parse(this.el.querySelector(this.selectors.variantsJson).textContent)
          return this.variantData
        }      
      }
  }
}